module.exports = __webpack_public_path__ + "img/freediving-5.69412cf3.jpeg";